import { useNavigate, useSearchParams } from "react-router-dom";
import FullPageMessage from "../../components/FullPageMessage/FullPageMessage";

function TikTokPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const success = searchParams.get("success");
  const errorMessage = searchParams.get("errorMessage");

  const handleNavigate = () => {
    navigate("/profile");
  };

  if (success === "true") {
    return (
      <FullPageMessage
        type="info"
        title="Success!"
        message="You should now see your TikTok data in your profile and displayed to brands!"
        actionButton={{
          label: "Go to Profile",
          onClick: handleNavigate,
        }}
      />
    );
  }

  if (errorMessage) {
    return (
      <FullPageMessage
        type="error"
        title="Something went wrong"
        message={errorMessage}
        actionButton={{
          label: "Go to Profile",
          onClick: handleNavigate,
        }}
      />
    );
  }

  return (
    <FullPageMessage
      type="warning"
      title="No status message"
      message="No success or error message was provided."
      actionButton={{
        label: "Go to Profile",
        onClick: handleNavigate,
      }}
    />
  );
}

export default TikTokPage;
